import React from 'react';
import SectionTitle from '../ui/SectionTitle';
import Card, { CardContent } from '../ui/Card';
import './IndustriesGrid.css';

const IndustriesGrid = () => {
    const industries = [{
            title: 'Banking & Financial Services',
            description: 'Secure and compliant debt recovery solutions for banks, credit unions, and financial institutions.'
        },
        {
            title: 'Telecommunications',
            description: 'Customer support and billing solutions for telecom providers and network operators.'
        },
        {
            title: 'Utilities & Energy',
            description: 'Payment reminder services and customer care for utility and energy companies.'
        },
        {
            title: 'E-commerce',
            description: 'Order support, payment processing, and customer service for online retailers.'
        },
        {
            title: 'Healthcare Billing',
            description: 'Medical billing assistance and patient payment recovery for healthcare providers.'
        },
        {
            title: 'Small & Medium Businesses',
            description: 'Tailored call center and debt recovery solutions for growing businesses.'
        }
    ];

    return ( <
        section className = "industries-section" >
        <
        div className = "container" >
        <
        SectionTitle subtitle = "INDUSTRIES"
        title = "Industries We Serve" /
        >

        <
        div className = "industries-grid" > {
            industries.map((industry, index) => ( <
                Card key = { index }
                className = "industry-card" >
                <
                CardContent >
                <
                h3 > { industry.title } < /h3> <
                p > { industry.description } < /p> <
                /CardContent> <
                /Card>
            ))
        } <
        /div> <
        /div> <
        /section>
    );
};

export default IndustriesGrid;